/* src/app/quickbooks/quickbooks-revoke-access/quickbooks-revoke-access.component.scss */
/*# sourceMappingURL=quickbooks-revoke-access.component.css.map */
